module.exports = require("./es-CR.js");